import React, { Component } from "react";
import { Paper, Grid, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import { BulkEditDatePickerCustom } from "util/bulk-edit-input-elements/BulkEditDatePickerCustom";
import moment from "moment";
import DeselectableRadioGroup from "util/bulk-edit-input-elements/DeselectableRadioGroup";
import {
  bulkEditOptionsType,
  bulkEditTextLength,
  bulkEditTextType,
} from "redux/Types";
import BulkEditTextInput from "util/bulk-edit-input-elements/BulkEditTextInput";
import BulkEditCustomSelect from "util/bulk-edit-input-elements/BulkEditCustomSelect";
import CustomChipInput from "util/bulk-edit-input-elements/CustomChipInput";

export class AlbumCommonUpdates extends Component {
  render() {
    const {
      classes,

      bulkEditData: {
        albumCommonEditing,
        job: { album_common_updates },
        validationErrors: { album_common_validation },
        sessionName,
      },
      handleAlbumCommonValueChange,
      editAlbumAppendValues,
      countries,
      albumType,
      vocals,
      loading,
      handleCommonAlbumRefreshValues,
      handleCommonAlbumAddChip,
      handleCommonAlbumDeleteChip,
    } = this.props;

    const commonUpdate = album_common_updates;
    const errors = album_common_validation;

    return (
      <div>
        {(loading || !sessionName) && (
          <div className={classes.overlay}>
            <CircularProgress size={200} className={classes.bulkEditLoading} />
          </div>
        )}
        <>
          <Paper className={classes.globalCreateBody}>
            <Grid container className={classes.globalCreateInput}>
              <div>
                <div className={clsx(classes.globalCreateContentWrapper)}>
                  <>
                    <Grid spacing={12}>
                      <Grid container>
                        <Grid item xs={4}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.prodSubtitle
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="prodSubtitle"
                                name="prodSubtitle"
                                title="Album Subtitle"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.prodSubtitle !== undefined
                                    ? commonUpdate.prodSubtitle !== null
                                      ? commonUpdate.prodSubtitle
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing?.prodSubtitle !==
                                        undefined
                                    ? albumCommonEditing.prodSubtitle !== null
                                      ? albumCommonEditing.prodSubtitle
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.prodSubtitle || commonUpdate.prodSubtitle == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues("prodSubtitle")
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.catNo
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="catNo"
                                name="catNo"
                                title="Catalog #"
                                // disabled
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.catNo !== undefined
                                    ? commonUpdate.catNo !== null
                                      ? commonUpdate.catNo
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing?.catNo !== undefined
                                    ? albumCommonEditing.catNo !== null
                                      ? albumCommonEditing.catNo
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.catNo || commonUpdate.catNo == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues("catNo")
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_catNo2
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_catNo2"
                                name="org_sky_catNo2"
                                title="Cat Number 2"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_catNo2 !== undefined
                                    ? commonUpdate.org_sky_catNo2 !== null
                                      ? commonUpdate.org_sky_catNo2
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_catNo2 !==
                                        undefined
                                    ? albumCommonEditing.org_sky_catNo2 !== null
                                      ? albumCommonEditing.org_sky_catNo2
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_catNo2 || commonUpdate.org_sky_catNo2 == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_catNo2"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_catNo3
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_catNo3"
                                name="org_sky_catNo3"
                                title="Cat Number 3"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_catNo3 !== undefined
                                    ? commonUpdate.org_sky_catNo3 !== null
                                      ? commonUpdate.org_sky_catNo3
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_catNo3 !==
                                        undefined
                                    ? albumCommonEditing.org_sky_catNo3 !== null
                                      ? albumCommonEditing.org_sky_catNo3
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_catNo3 || commonUpdate.org_sky_catNo3 == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_catNo3"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.prodArtist
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="prodArtist"
                                name="prodArtist"
                                title="Artist"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.prodArtist !== undefined
                                    ? commonUpdate.prodArtist !== null
                                      ? commonUpdate.prodArtist
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.prodArtist !==
                                        undefined
                                    ? albumCommonEditing.prodArtist !== null
                                      ? albumCommonEditing.prodArtist
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.prodArtist || commonUpdate.prodArtist == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues("prodArtist")
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.prodNumberOfDiscs
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="prodNumberOfDiscs"
                                name="prodNumberOfDiscs"
                                title="Number of Discs"
                                type={bulkEditTextType.NUMBER}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.prodNumberOfDiscs !== undefined
                                    ? commonUpdate.prodNumberOfDiscs !== null
                                      ? commonUpdate.prodNumberOfDiscs
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.prodNumberOfDiscs !==
                                        undefined
                                    ? albumCommonEditing.prodNumberOfDiscs !==
                                      null
                                      ? albumCommonEditing.prodNumberOfDiscs
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.prodNumberOfDiscs || commonUpdate.prodNumberOfDiscs == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "prodNumberOfDiscs"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.prodRelease
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditDatePickerCustom
                                name="prodRelease"
                                title="Release Date"
                                arialabel="Release Date"
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                // minDate={new Date(Date.now())}
                                classes={classes}
                                className={
                                  classes.tableFilterDateInputWithClear
                                }
                                autoOk={true}
                                inputProps={{ "aria-label": " Release Date" }}
                                clearValueButton={true}
                                value={
                                  commonUpdate &&
                                  commonUpdate.prodRelease !== undefined
                                    ? commonUpdate.prodRelease
                                    : albumCommonEditing &&
                                      albumCommonEditing.prodRelease !==
                                        undefined
                                    ? albumCommonEditing.prodRelease
                                    : null
                                }
                                onChange={(event) => {
                                  handleAlbumCommonValueChange({
                                    target: {
                                      name: "prodRelease",
                                      type: "datetime",
                                      value: event
                                        ? moment(event).format("yyyy-MM-DD")
                                        : "",
                                    },
                                  });
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.prodRelease || commonUpdate.prodRelease == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues("prodRelease")
                                }
                                onClearValueEvent={(event) => {
                                  handleAlbumCommonValueChange({
                                    target: {
                                      name: "prodRelease",
                                      type: "datetime",
                                      value: null,
                                    },
                                  });
                                }}
                              />
                            </div>

                            {/* <div className={clsx('singleBlock', (commonUpdate && (commonUpdate.org_sky_ReleaseDate || commonUpdate.org_sky_ReleaseDate=="") ? classes.edit_border_color:"") ) }>

                                    <BulkEditTextInput
                                        id="org_sky_ReleaseDate"
                                        name="org_sky_ReleaseDate"
                                        title="Released"
                                        type={bulkEditTextType.TEXT}
                                        classes={classes}                                       
                                        value={commonUpdate && commonUpdate.org_sky_ReleaseDate !== undefined
                                            ? commonUpdate.org_sky_ReleaseDate !== null ?  commonUpdate.org_sky_ReleaseDate :""
                                            : albumCommonEditing && albumCommonEditing.org_sky_ReleaseDate !== undefined
                                            ? albumCommonEditing.org_sky_ReleaseDate !== null ?  albumCommonEditing.org_sky_ReleaseDate :""
                                            : ""}    
                                         maxLength={bulkEditTextLength.SMALL}                                           
                                        handleChange={(event) => handleAlbumCommonValueChange(event, bulkEditTextLength.SMALL)}
                                        refreshDisabled={true}
//refreshDisabled={(commonUpdate && (commonUpdate.org_sky_ReleaseDate || commonUpdate.org_sky_ReleaseDate=="") ? false : true  )}
                                        refreshOnClick={() => handleCommonAlbumRefreshValues("org_sky_ReleaseDate")}
                                        errors={album_common_validation || {}}                                                                                     
                                    />
                                </div> */}

                            {/* <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_ReleaseDate
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditDatePickerCustom
                                name="org_sky_ReleaseDate"
                                title="Release Date (Sky)"
                                arialabel="Release Date (Sky)"
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                // minDate={new Date(Date.now())}
                                classes={classes}
                                className={
                                  classes.tableFilterDateInputWithClear
                                }
                                autoOk={true}
                                inputProps={{ "aria-label": " Release Date (Sky)" }}
                                clearValueButton={true}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_ReleaseDate !== undefined
                                    ? commonUpdate.org_sky_ReleaseDate
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_ReleaseDate !==
                                        undefined
                                    ? albumCommonEditing.org_sky_ReleaseDate
                                    : null
                                }
                                onChange={(event) => {
                                  handleAlbumCommonValueChange({
                                    target: {
                                      name: "org_sky_ReleaseDate",
                                      type: "datetime",
                                      value: event
                                        ? moment(event).format("yyyy-MM-DD")
                                        : "",
                                    },
                                  });
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_ReleaseDate ||commonUpdate.org_sky_ReleaseDate == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_ReleaseDate"
                                  )
                                }
                                onClearValueEvent={(event) => {
                                  handleAlbumCommonValueChange({
                                    target: {
                                      name: "org_sky_ReleaseDate",
                                      type: "datetime",
                                      value: null,
                                    },
                                  });
                                }}
                              />
                            </div> */}

                            <div
                              className={
                                editAlbumAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    commonUpdate.org_sky_CompanyDetails
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_CompanyDetails"
                                  name="org_sky_CompanyDetails"
                                  title="Company Details"
                                  isAppend={true}
                                  type={bulkEditTextType.TEXT}
                                  multiline
                                  rows={4}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_CompanyDetails !==
                                      undefined
                                      ? commonUpdate.org_sky_CompanyDetails !==
                                        null
                                        ? commonUpdate.org_sky_CompanyDetails
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_CompanyDetails !==
                                          undefined
                                      ? albumCommonEditing.org_sky_CompanyDetails !==
                                        null
                                        ? albumCommonEditing.org_sky_CompanyDetails
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.LARGE}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_CompanyDetails || commonUpdate.org_sky_CompanyDetails == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_CompanyDetails"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs={4}>
                          <div className="fieldBlock">
                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate &&
                                  commonUpdate.org_sky_TownCityState
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_TownCityState"
                                name="org_sky_TownCityState"
                                title="Town/City/State"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_TownCityState !==
                                    undefined
                                    ? commonUpdate.org_sky_TownCityState !==
                                      null
                                      ? commonUpdate.org_sky_TownCityState
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_TownCityState !==
                                        undefined
                                    ? albumCommonEditing.org_sky_TownCityState !==
                                      null
                                      ? albumCommonEditing.org_sky_TownCityState
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_TownCityState || commonUpdate.org_sky_TownCityState == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_TownCityState"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_Country
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="org_sky_Country"
                                name="org_sky_Country"
                                title="Country"
                                disableUnderline
                                options={countries}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_Country !== undefined
                                    ? commonUpdate.org_sky_Country !== null
                                      ? commonUpdate.org_sky_Country
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_Country !==
                                        undefined
                                    ? albumCommonEditing.org_sky_Country !==
                                      null
                                      ? albumCommonEditing.org_sky_Country
                                      : ""
                                    : ""
                                }
                                onChange={(event) => {
                                  handleAlbumCommonValueChange(event);
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Country || commonUpdate.org_sky_Country == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_Country"
                                  )
                                }
                                errors={album_common_validation}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.org_sky_Country
                                    ? classes.customError
                                    : {}
                                )}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_NumberMedia
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_NumberMedia"
                                name="org_sky_NumberMedia"
                                title="Number Media"
                                type={bulkEditTextType.NUMBER}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_NumberMedia !== undefined
                                    ? commonUpdate.org_sky_NumberMedia !== null
                                      ? commonUpdate.org_sky_NumberMedia
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_NumberMedia !==
                                        undefined
                                    ? albumCommonEditing.org_sky_NumberMedia !==
                                      null
                                      ? albumCommonEditing.org_sky_NumberMedia
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_NumberMedia ||commonUpdate.org_sky_NumberMedia == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_NumberMedia"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_Plugger1
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_Plugger1"
                                name="org_sky_Plugger1"
                                title="Plugger 1"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_Plugger1 !== undefined
                                    ? commonUpdate.org_sky_Plugger1 !== null
                                      ? commonUpdate.org_sky_Plugger1
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_Plugger1 !==
                                        undefined
                                    ? albumCommonEditing.org_sky_Plugger1 !==
                                      null
                                      ? albumCommonEditing.org_sky_Plugger1
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Plugger1 || commonUpdate.org_sky_Plugger1 == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_Plugger1"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate &&
                                  commonUpdate.org_sky_ChartPosition
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_ChartPosition"
                                name="org_sky_ChartPosition"
                                title="Chart Position"
                                type={bulkEditTextType.NUMBER}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_ChartPosition !==
                                    undefined
                                    ? commonUpdate.org_sky_ChartPosition !==
                                      null
                                      ? commonUpdate.org_sky_ChartPosition
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_ChartPosition !==
                                        undefined
                                    ? albumCommonEditing.org_sky_ChartPosition !==
                                      null
                                      ? albumCommonEditing.org_sky_ChartPosition
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_ChartPosition || commonUpdate.org_sky_ChartPosition == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_ChartPosition"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate &&
                                  //commonUpdate.org_sky_Label ||
                                  commonUpdate.org_sky_Label?.length > 0
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              {/* <CustomChipInput
                                id="org_sky_Label"
                                name="org_sky_Label"
                                title="Label"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                maxLength={bulkEditTextLength.SMALL}
                                onAdd={(chip) =>
                                  handleCommonAlbumAddChip(
                                    chip,
                                    "org_sky_Label"
                                  )
                                }
                                onDelete={(chip) =>
                                  handleCommonAlbumDeleteChip(
                                    chip,
                                    "org_sky_Label"
                                  )
                                }
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_Label !== undefined
                                    ? commonUpdate.org_sky_Label !== null
                                      ? commonUpdate.org_sky_Label
                                      : []
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_Label !==
                                        undefined
                                    ? albumCommonEditing.org_sky_Label !== null
                                      ? albumCommonEditing.org_sky_Label
                                      : []
                                    : []
                                }
                              /> */}

                              <BulkEditTextInput
                                id="org_sky_Label"
                                name="org_sky_Label"
                                title="Label"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_Label !== undefined
                                    ? commonUpdate.org_sky_Label !== null
                                      ? commonUpdate.org_sky_Label
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_Label !==
                                        undefined
                                    ? albumCommonEditing.org_sky_Label !== null
                                      ? albumCommonEditing.org_sky_Label
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Label || commonUpdate.org_sky_Label == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_Label"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate &&
                                  commonUpdate.org_sky_ArtistSocialWebsite
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditTextInput
                                id="org_sky_ArtistSocialWebsite"
                                name="org_sky_ArtistSocialWebsite"
                                title="Social Site"
                                type={bulkEditTextType.TEXT}
                                classes={classes}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_ArtistSocialWebsite !==
                                    undefined
                                    ? commonUpdate.org_sky_ArtistSocialWebsite !==
                                      null
                                      ? commonUpdate.org_sky_ArtistSocialWebsite
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_ArtistSocialWebsite !==
                                        undefined
                                    ? albumCommonEditing.org_sky_ArtistSocialWebsite !==
                                      null
                                      ? albumCommonEditing.org_sky_ArtistSocialWebsite
                                      : ""
                                    : ""
                                }
                                maxLength={bulkEditTextLength.SMALL}
                                handleChange={(event) =>
                                  handleAlbumCommonValueChange(
                                    event,
                                    bulkEditTextLength.SMALL
                                  )
                                }
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_ArtistSocialWebsite || commonUpdate.org_sky_ArtistSocialWebsite =="")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_ArtistSocialWebsite"
                                  )
                                }
                                errors={album_common_validation || {}}
                              />
                            </div>

                            <div
                              className={clsx(
                                "singleBlock",
                                commonUpdate && commonUpdate.org_sky_AlbumTypeID
                                  ? classes.edit_border_color
                                  : ""
                              )}>
                              <BulkEditCustomSelect
                                id="org_sky_AlbumTypeID"
                                name="org_sky_AlbumTypeID"
                                title="Type"
                                disableUnderline
                                options={albumType}
                                value={
                                  commonUpdate &&
                                  commonUpdate.org_sky_AlbumTypeID !== undefined
                                    ? commonUpdate.org_sky_AlbumTypeID !== null
                                      ? commonUpdate.org_sky_AlbumTypeID
                                      : ""
                                    : albumCommonEditing &&
                                      albumCommonEditing.org_sky_AlbumTypeID !==
                                        undefined
                                    ? albumCommonEditing.org_sky_AlbumTypeID !==
                                      null
                                      ? albumCommonEditing.org_sky_AlbumTypeID
                                      : ""
                                    : ""
                                }
                                onChange={(event) => {
                                  handleAlbumCommonValueChange(event);
                                }}
                                refreshDisabled={true}
                                //refreshDisabled={commonUpdate && (commonUpdate.org_sky_AlbumTypeID || commonUpdate.org_sky_AlbumTypeID == "")? false : true}
                                refreshOnClick={() =>
                                  handleCommonAlbumRefreshValues(
                                    "org_sky_AlbumTypeID"
                                  )
                                }
                                errors={album_common_validation || {}}
                                classes={classes}
                                className={clsx(
                                  classes.appbarSelect,
                                  classes.advancedSearchMainDropdown,
                                  errors?.org_sky_AlbumTypeID
                                    ? classes.customError
                                    : {}
                                )}
                              />
                            </div>

                            <div
                              className={
                                editAlbumAppendValues
                                  ? classes.border_color
                                  : ""
                              }>
                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    commonUpdate.org_sky_LibrarianNotes
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_LibrarianNotes"
                                  name="org_sky_LibrarianNotes"
                                  title="Librarian Notes"
                                  type={bulkEditTextType.TEXT}
                                  multiline
                                  isAppend={true}
                                  rows={4}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_LibrarianNotes !==
                                      undefined
                                      ? commonUpdate.org_sky_LibrarianNotes !==
                                        null
                                        ? commonUpdate.org_sky_LibrarianNotes
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_LibrarianNotes !==
                                          undefined
                                      ? albumCommonEditing.org_sky_LibrarianNotes !==
                                        null
                                        ? albumCommonEditing.org_sky_LibrarianNotes
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.LARGE}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.LARGE
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_LibrarianNotes || commonUpdate.org_sky_LibrarianNotes == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_LibrarianNotes"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs={4}>
                          <div>
                            <div className="fieldBlock">
                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate && commonUpdate.org_sky_Vocal
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditCustomSelect
                                  id="org_sky_Vocal"
                                  name="org_sky_Vocal"
                                  title="Vocal"
                                  disableUnderline
                                  options={vocals}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_Vocal !== undefined
                                      ? commonUpdate.org_sky_Vocal !== null
                                        ? commonUpdate.org_sky_Vocal
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_Vocal !==
                                          undefined
                                      ? albumCommonEditing.org_sky_Vocal !==
                                        null
                                        ? albumCommonEditing.org_sky_Vocal
                                        : ""
                                      : ""
                                  }
                                  onChange={(event) => {
                                    handleAlbumCommonValueChange(event);
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Vocal || commonUpdate.org_sky_Vocal == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_Vocal"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                  classes={classes}
                                  className={clsx(
                                    classes.appbarSelect,
                                    classes.advancedSearchMainDropdown,
                                    errors?.org_sky_Vocal
                                      ? classes.customError
                                      : {}
                                  )}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    commonUpdate.org_sky_ArtistWebsite
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_ArtistWebsite"
                                  name="org_sky_ArtistWebsite"
                                  title="Artist Website"
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_ArtistWebsite !==
                                      undefined
                                      ? commonUpdate.org_sky_ArtistWebsite !==
                                        null
                                        ? commonUpdate.org_sky_ArtistWebsite
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_ArtistWebsite !==
                                          undefined
                                      ? albumCommonEditing.org_sky_ArtistWebsite !==
                                        null
                                        ? albumCommonEditing.org_sky_ArtistWebsite
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_ArtistWebsite || commonUpdate.org_sky_ArtistWebsite == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_ArtistWebsite"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    commonUpdate.org_sky_LabelWebsite
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_LabelWebsite"
                                  name="org_sky_LabelWebsite"
                                  title="Label Website"
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_LabelWebsite !==
                                      undefined
                                      ? commonUpdate.org_sky_LabelWebsite !==
                                        null
                                        ? commonUpdate.org_sky_LabelWebsite
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_LabelWebsite !==
                                          undefined
                                      ? albumCommonEditing.org_sky_LabelWebsite !==
                                        null
                                        ? albumCommonEditing.org_sky_LabelWebsite
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_LabelWebsite || commonUpdate.org_sky_LabelWebsite == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_LabelWebsite"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate && commonUpdate.org_sky_Publisher
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Publisher"
                                  name="org_sky_Publisher"
                                  title="Publisher"
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_Publisher !== undefined
                                      ? commonUpdate.org_sky_Publisher !== null
                                        ? commonUpdate.org_sky_Publisher
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_Publisher !==
                                          undefined
                                      ? albumCommonEditing.org_sky_Publisher !==
                                        null
                                        ? albumCommonEditing.org_sky_Publisher
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Publisher || commonUpdate.org_sky_Publisher == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_Publisher"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate && commonUpdate.org_sky_Company
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Company"
                                  name="org_sky_Company"
                                  title="Company"
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_Company !== undefined
                                      ? commonUpdate.org_sky_Company !== null
                                        ? commonUpdate.org_sky_Company
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_Company !==
                                          undefined
                                      ? albumCommonEditing.org_sky_Company !==
                                        null
                                        ? albumCommonEditing.org_sky_Company
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumCommonValueChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_Company || commonUpdate.org_sky_Company == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_Company"
                                    )
                                  }
                                  errors={album_common_validation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    (commonUpdate.org_sky_IsMCPSBlanket ===
                                      true ||
                                      commonUpdate.org_sky_IsMCPSBlanket ===
                                        false)
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <DeselectableRadioGroup
                                  ariaLabel="org_sky_IsMCPSBlanket"
                                  name="org_sky_IsMCPSBlanket"
                                  title="Non-MCPS"
                                  options={bulkEditOptionsType}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_IsMCPSBlanket !==
                                      undefined
                                      ? commonUpdate.org_sky_IsMCPSBlanket !==
                                        null
                                        ? commonUpdate.org_sky_IsMCPSBlanket == true || commonUpdate.org_sky_IsMCPSBlanket == 1 ? false 
                                        : commonUpdate.org_sky_IsMCPSBlanket == false || commonUpdate.org_sky_IsMCPSBlanket == 0 ? true : ""
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_IsMCPSBlanket !==
                                          undefined
                                      ? albumCommonEditing.org_sky_IsMCPSBlanket !==
                                        null
                                        ? albumCommonEditing.org_sky_IsMCPSBlanket == true || albumCommonEditing.org_sky_IsMCPSBlanket == 1 ? false
                                        : albumCommonEditing.org_sky_IsMCPSBlanket == false || albumCommonEditing.org_sky_IsMCPSBlanket == 0  ? true : ""
                                        : ""
                                      : null
                                  }
                                  onChange={(event) =>
                                    {
                                       var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                     && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                      handleAlbumCommonValueChange(changes);
                                    }}
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_IsMCPSBlanket || commonUpdate.org_sky_IsMCPSBlanket == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_IsMCPSBlanket"
                                    )
                                  }
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  commonUpdate &&
                                    (commonUpdate.org_sky_IsPPLBlanket ===
                                      true ||
                                      commonUpdate.org_sky_IsPPLBlanket ===
                                        false)
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <DeselectableRadioGroup
                                  ariaLabel="org_sky_IsPPLBlanket"
                                  name="org_sky_IsPPLBlanket"
                                  title="Non-PPL"
                                  options={bulkEditOptionsType}
                                  classes={classes}
                                  value={
                                    commonUpdate &&
                                    commonUpdate.org_sky_IsPPLBlanket !==
                                      undefined
                                      ? commonUpdate.org_sky_IsPPLBlanket !==
                                        null
                                        ? commonUpdate.org_sky_IsPPLBlanket == true || commonUpdate.org_sky_IsPPLBlanket == 1  ? false 
                                        : commonUpdate.org_sky_IsPPLBlanket == false || commonUpdate.org_sky_IsPPLBlanket == 0 ? true : ""
                                        : ""
                                      : albumCommonEditing &&
                                        albumCommonEditing.org_sky_IsPPLBlanket !==
                                          undefined
                                      ? albumCommonEditing.org_sky_IsPPLBlanket !==
                                        null
                                        ? albumCommonEditing.org_sky_IsPPLBlanket == true || albumCommonEditing.org_sky_IsPPLBlanket == 1 ? false
                                        : albumCommonEditing.org_sky_IsPPLBlanket == false || albumCommonEditing.org_sky_IsPPLBlanket == 0 ? true : ""
                                        : ""
                                      : null
                                  }
                                  onChange={(event) =>
                                    {
                                       var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                     && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                      handleAlbumCommonValueChange(changes);
                                    }}
                                  refreshDisabled={true}
                                  //refreshDisabled={commonUpdate && (commonUpdate.org_sky_IsPPLBlanket || commonUpdate.org_sky_IsPPLBlanket == "")?false:true}
                                  refreshOnClick={() =>
                                    handleCommonAlbumRefreshValues(
                                      "org_sky_IsPPLBlanket"
                                    )
                                  }
                                />
                              </div>

                              <div
                                className={
                                  editAlbumAppendValues
                                    ? classes.border_color
                                    : ""
                                }>
                                <div
                                  className={clsx(
                                    "singleBlock",
                                    commonUpdate && commonUpdate.prodNotes
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <BulkEditTextInput
                                    id="prodNotes"
                                    name="prodNotes"
                                    title="Notes"
                                    type={bulkEditTextType.TEXT}
                                    multiline
                                    isAppend={true}
                                    rows={4}
                                    classes={classes}
                                    value={
                                      commonUpdate &&
                                      commonUpdate.prodNotes !== undefined
                                        ? commonUpdate.prodNotes !== null
                                          ? commonUpdate.prodNotes
                                          : ""
                                        : albumCommonEditing &&
                                          albumCommonEditing.prodNotes !==
                                            undefined
                                        ? albumCommonEditing.prodNotes !== null
                                          ? albumCommonEditing.prodNotes
                                          : ""
                                        : ""
                                    }
                                    maxLength={bulkEditTextLength.LARGE}
                                    handleChange={(event) =>
                                      handleAlbumCommonValueChange(
                                        event,
                                        bulkEditTextLength.LARGE
                                      )
                                    }
                                    refreshDisabled={true}
                                    //refreshDisabled={commonUpdate && (commonUpdate.prodNotes || commonUpdate.prodNotes == "")? false:true}
                                    refreshOnClick={() =>
                                      handleCommonAlbumRefreshValues(
                                        "prodNotes"
                                      )
                                    }
                                    errors={album_common_validation || {}}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                </div>
              </div>
            </Grid>
          </Paper>
        </>
      </div>
    );
  }
}

export default AlbumCommonUpdates;
